import React from "react";
import { VOLTECH_LIVE } from "@/data/landing";
import { Activity, ArrowUpRight } from "lucide-react";

export default function VoltechLive() {
  return (
    <section className="py-20 md:py-28 border-b border-white/10 bg-[#0a0a0c]" data-testid="section-voltech-live">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="industrial-card p-8 md:p-14 relative overflow-hidden">
          <div
            className="absolute -top-24 -right-24 w-80 h-80 opacity-20 pointer-events-none"
            style={{ background: "radial-gradient(circle, #e63946 0%, transparent 70%)" }}
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="eyebrow flex items-center gap-2">
                <Activity size={14} className="text-[#e63946]" /> Our moat · {VOLTECH_LIVE.tagline}
              </div>
              <h2 className="font-display text-3xl md:text-5xl uppercase mt-4 tracking-tighter leading-[0.95]">
                Every battery ships with
                <span className="text-[#e63946]"> {VOLTECH_LIVE.name}</span>
              </h2>
              <p className="text-zinc-400 mt-5 max-w-xl text-sm md:text-base leading-relaxed">
                {VOLTECH_LIVE.description}
              </p>
              <a
                href={VOLTECH_LIVE.url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary mt-7"
                data-testid="voltech-live-link"
              >
                Visit {VOLTECH_LIVE.name} <ArrowUpRight size={16} />
              </a>
            </div>
            <div className="lg:col-span-5 grid grid-cols-2 gap-3">
              {VOLTECH_LIVE.metrics.map((m, i) => (
                <div key={i} className="industrial-card p-5" data-testid={`voltech-metric-${i}`}>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                    Live
                  </div>
                  <div className="font-display text-base uppercase mt-2 leading-tight text-[#e63946]">
                    {m}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
